import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=970561b8&scoped=true&"
import script from "./Review.vue?vue&type=script&lang=js&"
export * from "./Review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970561b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('970561b8')) {
      api.createRecord('970561b8', component.options)
    } else {
      api.reload('970561b8', component.options)
    }
    module.hot.accept("./Review.vue?vue&type=template&id=970561b8&scoped=true&", function () {
      api.rerender('970561b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepTwo/StarterSite/Review.vue"
export default component.exports